import { ReactElement } from 'react';
import clone from 'lodash/clone';
import type { TechnologyMaterial, WidgetTechnology } from '@services/df/technologies';
import { sortByArray } from '../arrays';
import { isCNC } from './is-cnc';

interface GetAvailableMaterials {
    technology: WidgetTechnology | undefined;
    material: TechnologyMaterial | undefined;
    suitable: number[];
    preselectionModeOn: boolean;
    fullPreselectionModeOn: boolean;
    isIqtModeOn: boolean;
    getMarkedLabel: (material: TechnologyMaterial) => ReactElement;
}

export function getAvailableMaterials({
    technology,
    material,
    suitable,
    preselectionModeOn,
    fullPreselectionModeOn,
    isIqtModeOn,
    getMarkedLabel,
}: GetAvailableMaterials) {
    if (!technology) return [];

    const sortedMaterials = clone(technology.materials).sort((a, b) => {
        return (a.sorting_priority ?? 0) - (b.sorting_priority ?? 0);
    });

    let availableMaterials = sortedMaterials.map(material => {
        const children = isIqtModeOn && material.is_iqt_only ? getMarkedLabel(material) : undefined;
        return { label: material.title, value: material.id, children };
    });

    if (preselectionModeOn) {
        if (isCNC(technology.tech_id) || fullPreselectionModeOn) {
            // include suitable and unsuitable material, but installed outside
            availableMaterials = availableMaterials.filter(m => m.value === material?.id || suitable.includes(m.value));
        }

        availableMaterials.sort(sortByArray({ arr: suitable, property: 'value', separateOnly: true }));
    }

    return availableMaterials;
}
